import { FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import { BroadcastHistorySection } from "./sections/broadcast-history.section";
import { DashboardHeader } from "../dashboards/dashboard-components";
import { DashboardWrapper } from "../dashboards/dashboard.style";

export const BroadcastHistoryPage = () => <DashboardWrapper>
  <DashboardHeader eyebrow="Marketing workspace" title="Broadcast history" description="Review broadcast delivery, audience, sender, and dispatch details." showActions={false} />
  <Link className="history-back-link" to="/admin/internal/marketing/broadcast"><FiArrowLeft aria-hidden="true" /> Back to broadcast</Link>
  <BroadcastHistorySection />
</DashboardWrapper>;
